import { FC, useCallback } from 'react';

import { SearchFieldType } from '@/__generated__/graphql';
import { useFilterContext } from '@/context/FilterProvider';
import { BaseFilterToggle } from './BaseFilterToggle';
import { ClearSelectAllButton } from './ClearSelectAllButton';
import { FilterSection, FilterSectionProps } from './FilterSection';

interface AdvancedFiltersProps extends FilterSectionProps {}

const SELECTION_LIST = [
  { label: 'Name', value: SearchFieldType.Name },
  { label: 'Column', value: SearchFieldType.Column },
  { label: 'Relation', value: SearchFieldType.Relation },
  { label: 'Description', value: SearchFieldType.Description },
  { label: 'Code', value: SearchFieldType.Code },
];

export const AdvancedFilters: FC<AdvancedFiltersProps> = ({ title = 'Advanced' }) => {
  const filterCtx = useFilterContext();

  const searchFields = filterCtx.filters?.searchFields;

  const handleToggle = useCallback(
    (field: SearchFieldType) => {
      const isAdding = !searchFields?.includes(field);
      filterCtx.updateFilters({ searchFields: [field] }, isAdding);
    },
    [filterCtx, searchFields],
  );
  return (
    <FilterSection title={title} enableExpansion>
      <ul className="mt-2">
        {SELECTION_LIST.map((selection) => (
          <li key={selection.value}>
            <BaseFilterToggle
              isChecked={searchFields?.includes(selection.value)}
              onToggle={() => {
                handleToggle(selection.value);
              }}
            >
              {selection.label}
            </BaseFilterToggle>
          </li>
        ))}
      </ul>
      <ClearSelectAllButton
        type="searchFields"
        selectedList={searchFields}
        selectionList={SELECTION_LIST}
      />
    </FilterSection>
  );
};
